<template>
  <v-container>
    <div class="sub_admin_top">
      <div class="header">
        <img src="assets/logo_2nd_tool.png" style="height: 50px;margin-right: 20px;">
        <h1 style="text-align:left;font-size: 43px;margin-bottom: 0px;">管理者ページ</h1>
        <div style="text-align: right; float: right; position: absolute; right: 3%;">
          <div class="header-info">
            <p style="font-size:20px;margin-top: 13px;margin-right: 20px;">ユーザー名: {{ user.name }}</p>
            <input style="float:right;color: black;padding-left: 10px; padding-right: 10px;  margin-top: 10px; margin-bottom: 10px;" class="btn btn-light" type="button" @click="showLogoutDialogue" value="ログアウト"/>
          </div>
        </div>
      </div>

      <div class="content" style="padding: 3%;background: #e3e2dd;">
        <div class="sub_domain">
          <div class="user-infomation" style="width: 100%; display: flex;">
            <div class="user-info-left" style="width: 50%;">
              <div class="table-title" style="text-align: center;padding: 5px;background: #00507a;color: white;font-size: 19px; margin-bottom: 20px;">
                <p style="margin-bottom: 0px;">ご契約内容</p>  
              </div>
              <div class="user-info-up" style="display: flex; margin-bottom: 20px;">
                <div class="user-info-box" style="height: 40px;width: 50%;border: 1px solid gray;border-radius: 6px;background: #f6f6f5;">
                 <p style="margin: 0px;padding: 8px;">▶登録名：{{ user.name }}</p> 
                </div>
                <div class="user-info-box" style="height: 40px;width: 50%;border: 1px solid gray;border-radius: 6px;background: #f6f6f5;">
                 <p style="margin: 0px;padding: 8px;">▶保存ルーム数：{{ user.roomcount }}</p>
                </div>
              </div>
              <div class="user-info-down" style="display: flex;"> 
                <div class="user-info-box" style="height: 40px;width: 50%;border: 1px solid gray;border-radius: 6px;background: #f6f6f5;">
                 <p style="margin: 0px;padding: 8px;">▶ご契約プラン：{{ user.plan }}</p>
                </div>
                <div class="user-info-box" style="height: 40px;width: 50%;border: 1px solid gray;border-radius: 6px;background: #f6f6f5;">
                 <p style="margin: 0px;padding: 8px;">▶ワンタイムルーム契約時間：{{ user.randomroomcount }}分</p>
                </div>
              </div>
            </div>

            <div class="user-info-right" style="width: 50%;">
              <div style="display: fiex;">
                <div class="room-remain">
                  <p style="font-size:18px;width: 100%; margin-bottom: 0;">現在の同時使用ルーム数: {{ currentRoomNum  }} / {{ user.roomTotal }}</p>
                  <v-progress-linear height="25" color="pink" :value="getRoomUsageRate()" reverse></v-progress-linear>
                </div>
                <div class="room-remain">
                  <p style="font-size:18px;width: 100%; margin-bottom: 0;">ワンタイムルーム時間: 残り{{ user.randomroomRemain  }}分</p>
                  <v-progress-linear height="25" color="green" :value="getRandomRoomRemainTime()" reverse></v-progress-linear>
                </div>
              </div>
              <div class="randomroom-password">
                <p style="font-size:18px;width: 55%; margin-bottom: 0;">ワンタイムルームパスワード</p>
                <input type="text" class="form-control" v-model="user.randomroomPassword"/>
                <v-btn style="height: 34px; min-width: 70px; margin-top: 1px; margin-left: 10px;" small color="primary" @click="saveRandromRoomPassword()">更新</v-btn>
              </div>
            </div>
          </div>
        </div>
        
        <table class="table" style="margin-top: 10px;">
          <thead style="background: #00507a!important;color: white;">
            <th>ルームNo.</th>
            <th>ルームURL</th>
            <th>パスワード</th>
            <th>URL</th>
            <th>作成日</th>
            <th>QRコード</th>
            <th>消禁</th>
            <th>備考</th>
            <th>操作</th>
          </thead>
          <template v-for="(room, index) in rooms">
            <tr :key="room.index">
                <td><p style="margin-bottom: 0px;">No{{index + 1}}</p></td>
                <td>
                  <div style="display: flex;">
                    <span style="margin-top: 8px;">https://{{ roomDomain() }}/</span>
                    <input type="text" class="form-control" v-model="room.name" :placeholder="notset"/>
                  </div>
                </td>
                <td><input type="text" class="form-control" v-model="room.password" :placeholder="notset"/></td>
                <td>
                  <button type="button" class="btn btn-dark"  @click="copyUrl(room);">
                    <span style="color: white;">コピー</span>
                  </button>
                </td>
                <td><p style="margin-top:12px;">{{ (room.created && room.name != "") ? getStringFromDate(new Date(room.created)) : "" }}</p></td>
                <td>
                  <button type="button" @click="showQrModal(room);">
                    <vue-qrcode v-if="room.name" :options="option" :value="roomUrl(room)" tag="img"></vue-qrcode>
                  </button>
                </td>
                <td><input type="checkbox" class="form-control" v-model="room.delban" /></td>
                <td><input type="text" class="form-control" v-model="room.remarks" :placeholder="notset"/></td>
                <td>
                  <div v-if="isChanged(room, index)">
                    <button type="button" class="btn btn-dark" style="color: white;background: #fdd112; border:0px solid black;" @click="updateClick(room, index);">
                      <span style="color: white;">更新</span>
                    </button>
                  </div>
                  <div v-else>
                    <button type="button" class="btn btn-dark" style="color: white;background: gray; border:0px solid black;" disabled>
                    <span style="color: white;">更新</span>
                    </button>
                  </div>
                </td>
            </tr>
          </template>
        </table>
        <div>
          <p>注意事項</p>
          <p>・保存ルームのURLは、作成日より1ヶ月経過しないと変更できません。</p>
          <p>・消禁にチェックを入れると、更新する際に管理者IDを求められます。</p>
          <p>・ルームURLは、半角英数字のみ有効です。最大24文字です。</p>
          <p>・ルームURL入力後に更新ボタンを押すと反映されます。</p>
        </div>
      </div>
    </div>
    <!-- 管理者ID確認モーダル -->
    <modal :name="checkModalName">
      <div class="modal-header">
        チェック
      </div>
      <div class="modal-body">
        <p>管理者IDを入力してください。</p>
        <input type="text" class="form-control" style="margin-bottom: 20px;" -model="adminId" placeholder="IDを入力してください。" />
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-success" @click="checkClick();$modal.hide(checkModalName);">確認</button>
        <button type="button" class="btn btn-secondary" @click="$modal.hide(checkModalName)">閉じる</button>
      </div>  
    </modal>
    <!-- メッセージ用モーダル -->
    <modal :name="modalName">
      <div class="modal-header">
        {{ title }}
      </div>
      <div class="modal-body">
        <p>{{ msg }}</p>
      </div>
      <div class="modal-footer">          
          <button type="button" class="btn btn-secondary" @click="$modal.hide(modalName)">閉じる</button>
      </div>
    </modal>
    <!-- QRモーダル -->    
    <modal :name="qrModalName" width='40vw' height='30vh'>
      <div class="modal-header">
        {{ (qrModalRoom) ? qrModalRoom.name : "none" }}
      </div>
      <div class="modal-body">
        <vue-qrcode v-if="qrModalRoom != null" :options="option_qrmodal" :value="roomUrl(qrModalRoom)" tag="img"></vue-qrcode>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="$modal.hide(qrModalName)">閉じる</button>
      </div>
    </modal>
    <!-- ログアウトモーダル -->    
    <modal :name="logoutModalName">
      <div class="modal-header">
        確認
      </div>
      <div class="modal-body">
        更新されてない内容がありますがログアウトしてよろしいですか？
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" @click="logout">ログアウト</button>
        <button type="button" class="btn btn-secondary" @click="$modal.hide(logoutModalName)">キャンセル</button>
      </div>
    </modal>    
  </v-container>
</template>

<script>
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import VueQrcode from "@chenfengyuan/vue-qrcode";

Vue.use(VueClipboard)

export default {
  components: {
    VueQrcode
  },
  data () {
    return {
      rooms: [],
      localRooms: [],
      notset: '未設定',
      user: {},
      adminId: '',
      checkModalName: 'check_modal',
      modalName: 'error_modal',
      qrModalName: 'qr_modal',
      logoutModalName: 'logout_modal',
      title: '',
      msg: '',
      qrModalRoom: null,
      selectRoom: {},
      option: {
        errorCorrectionLevel: "M",
        maskPattern: 0,
        margin: 1,
        scale: 1,
        width: 50,
        color: {
          dark: "#000000FF",
          light: "#FFFFFFFF"
        }
      },
      option_qrmodal: {
        errorCorrectionLevel: "M",
        maskPattern: 0,
        margin: 2,
        scale: 2,
        width: 300,
        color: {
          dark: "#000000FF",
          light: "#FFFFFFFF"
        }
      },  
      currentRoomNum: 0
    }
  },
  methods: {
    // 更新ボタンクリック
    updateClick(room, index) {
      let localRoom = this.localRooms.filter(r => r.id == room.id);
      localRoom = localRoom && localRoom.length > 0 ? localRoom[0] : {};
      if (room.name == localRoom.name) {
        this.update(room);
        return;
      }
        
      if( confirm('現在作成したURLを更新すると、このルームNoでは1ヶ月間更新できませんがよろしいですか？') == false ){
        return;
      }

      if (!this.formCheck(room)) {
        this.rooms[index].name = localRoom.name;
        return;
      }
      if (room.id !== 0 && localRoom.delban) {
        this.selectRoom = room;
        this.adminId = '';
        this.selectRoom.isNameChanged = ( localRoom.name != this.selectRoom.name );
        this.$modal.show(this.checkModalName);
        return;
      } else {
        room.created = new Date();
        this.update(room);
      }
    },
    // 入力確認
    formCheck(room) {
      let roomName = room && room.name ? room.name : '';
      if(!roomName.match(/^[A-Za-z0-9]*$/)){
        this.messageModalShow('エラー', 'ルームURLは半角英数字で入力してください。');
        return false;
      } else if (roomName.length > 24) {
        this.messageModalShow('エラー', 'ルームURLは24文字以内で入力してください。');
        return false;
      }
      if (room.id !== 0) {
        let date = new Date(room.created);
        date.setMonth(date.getMonth() + 1);
        if (date > new Date()) {
          this.messageModalShow('エラー', 'ルームURLは作成日から1ヶ月は変更できません。\n' + '次回更新可能日は' + this.getStringFromDate(date) + 'です。');
          return false;
        }
      }
      let sameNameRooms = this.localRooms.filter(r => r.name == room.name);
      if (sameNameRooms.length > 0){        
          this.messageModalShow('エラー', '同一URLのルームがあります。\n');
          return false;
      }
      return true;
    },
    //日付から文字列に変換する関数
    getStringFromDate(date) {
      let format_str = 'YYYY/MM/DD';
      format_str = format_str.replace(/YYYY/g, date.getFullYear());
      format_str = format_str.replace(/MM/g, date.getMonth() + 1);
      format_str = format_str.replace(/DD/g, date.getDate());
      format_str = format_str.replace(/hh/g, date.getHours());
      format_str = format_str.replace(/mm/g, date.getMinutes());
      format_str = format_str.replace(/ss/g, date.getSeconds());
      return format_str;
    },
    // 確認ボタンクリック
    checkClick() {
      /*
      // idが正しければ更新
      if (this.adminId === this.user.userId) {
        this.update(this.selectRoom);
      } else {
        this.messageModalShow('エラー', '管理者IDが違います。');
      }
      */
      this.$axios.get('/auth/email/' + this.user.name + '/password/' + this.adminId)
          .then(res => {
              // メッセージがある場合は表示のみ行う
              if (res.data.msg) {
                  this.msg = res.data.msg;
                  this.$modal.show(this.errorModalName);
                  this.messageModalShow('エラー', '管理者IDが違います。');
              }
              if (res.status == 200) {
                if( this.selectRoom.isNameChanged ){
                  this.selectRoom.created = new Date();
                }
                this.update(this.selectRoom);
              }
          })
          .catch((err) => {
              console.log(err);
              this.messageModalShow('エラー', '管理者IDが違います。');
          });
    },
    // 更新処理
    update(room) {
      if( room.name == "" ){
        room.created = null
      }
      room.updated = new Date();
      // 良いのか @TODO
      room.inCount = 0;
      this.$axios.post('/update/room/' + JSON.stringify(room))
          .then(res => {
            if (res.status === 200) {
              this.fetchRooms();
              this.messageModalShow('更新完了', '更新に成功しました。');
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    copyUrl(room){
        let url = this.roomUrl(room);
        this.$copyText(url).then(function () {
           alert('URLをコピーしました');
        }, function (e) {
           alert('URLをコピーに失敗しました' + e);
        })
    },
    roomDomain(){
        return window.location.host.replace("control", this.user.subdomain)
    },
    roomUrl(room){
        return "https://" + this.roomDomain() + "/" + room.name;
    },
    fetchRooms() {
      this.rooms = []
      this.localRooms = []
      this.$axios.get('/rooms/userId/' + this.user.id)
          .then(res => {
            let rooms = res.data.rooms;
            if (rooms) {
              rooms.forEach(room => {
                this.rooms.push(this.adjustRoom(room));
                this.localRooms.push(this.adjustRoom(room));
              });
              let roomCount = this.user.roomcount ? this.user.roomcount : 0;
              let uncount = roomCount - rooms.length;
              for(let i = 0; i < uncount; i++) {
                this.rooms.push(this.adjustRoom({userId: this.user.id}));
                this.localRooms.push(this.adjustRoom({userId: this.user.id}));
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
    },
    async fetchRandomRooms() {
      this.currentRoomNum = 0
      let res = await this.$axios.get('/rooms/userId/' + this.user.id)
      if( res.data.rooms ){
        if( res.data.rooms.length > 0 ){
          res.data.rooms.forEach( room => {
            if( room.inCount && room.inCount > 1 ){
              this.currentRoomNum++;
            }
          })
        }
      }
      res = await this.$axios.get('/randomrooms/userId/' + this.user.id)
      if( res.data.rooms ){
        if( res.data.rooms.length > 0 ){
          res.data.rooms.forEach( room => {
            if( room.inCount && room.inCount > 1 ){
              this.currentRoomNum++;
            }
          })
        }        
      }
    },
    messageModalShow(title, msg) {
      this.title = title;
      this.msg = msg;
      this.$modal.show(this.modalName);
    },
    getRoomUsageRate(){
      return Math.round(this.currentRoomNum/this.user.roomTotal * 100);
    },
    getRandomRoomRemainTime(){
      return Math.round(this.user.randomroomRemain/this.user.randomroomcount * 100);
    },
    isChanged(room, index){
      return (room.name != this.localRooms[index].name || room.password != this.localRooms[index].password || room.remarks != this.localRooms[index].remarks);
    },
    isRoomsChanged(){
      let result = false;
      for( let i = 0 ; i < this.rooms.length ; i++ ){
        if ( this.rooms[i].name != this.localRooms[i].name 
          || this.rooms[i].password != this.localRooms[i].password 
          || this.rooms[i].delban != this.localRooms[i].delban 
          || this.rooms[i].remarks != this.localRooms[i].remarks )
        {
          result = true;
          break;
        }
      }
      return result;
    },
    showQrModal(room){
      this.qrModalRoom = room;
      this.$modal.show(this.qrModalName);
    },
    showLogoutDialogue(){
      if( this.isRoomsChanged() ){
        this.$modal.show(this.logoutModalName);
      }
      else{
        this.$store.state.user = {};
        this.$router.push('/');
      }
    },
    async saveRandromRoomPassword(){
      let res = await this.$axios.post('/editUser/' + JSON.stringify(this.user));
      if (res.status === 200) {
          //this.$router.push('/admintop');
          this.msg = "保存に成功しました";
          this.$modal.show(this.modalName);
      }
      else {
          this.msg = "保存に失敗しました";
          this.$modal.show(this.modalName);
      }      
    }
  },
  created: function () {
    this.existUser();
    this.user = this.adjustUser(this.$store.state.user)
    this.fetchRooms();
    this.fetchRandomRooms();
  },
}
</script>

<style scope>
.container {
  max-width: 100%!important;
  padding: 0px;
}

.header {
  background:#a3d4c5;
  display: flex;
  padding: 22px;
  padding-left: 3%;
  padding-right: 3%;  
  color: white;
}

.header-info {
  display: flex;
}

.table {
  background: white;
}

.table td {
  vertical-align: middle;
}

.room-remain {
  padding: 0px 20px;
  width: 100%;
  margin-bottom: 10px;
}

.modal-header, .modal-body {
  padding: 5px 25px;
  text-align: center;
}

.randomroom-password {
  display: flex;
  line-height: 40px;
  padding: 0px 20px;
}
</style>
